import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/chat-interface/components/ChatInterfaceInteractive.tsx");
